import React from "react";
import Routes from "./pages/Routes";
import "./assets/styles/global.css";

function App() {
  return <Routes />
}

export default App;
